// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__YKiE7","colCheckbox":"styles_colCheckbox__39Fit"};